import React, {  } from "react";
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import StartPage from "./components/StartPage"
import Observations from "./components/Observations.js";
import ObservationContainer from "./components/ObservationContainer.js";
import FeaturesContainer from "./components/FeaturesContainer.js";
import SettingsContainer from "./components/SettingsContainer.js";
import VisitContainer from './components/VisitContainer'
import LocationPicker from "./components/61/LocationPicker";
import { useStore } from './Store'
import AppProviders from "./components/AppProviders";


const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useStore()
  if (!user) {
    return <Route {...rest} render={(props) => (<Redirect to='/login' />)} />
  } else {
    return <Route {...rest} render={(props) => (<Component {...props} />)} />
  }
}

const App = () => {
  return (
    <AppProviders>
      <Router>
        <Switch>
          <PrivateRoute exact path='/features' component={FeaturesContainer} />
          <PrivateRoute exact path='/' component={StartPage} />
          <PrivateRoute exact path='/settings' component={SettingsContainer} />
          <PrivateRoute exact path='/details' component={VisitContainer} />
          <PrivateRoute exact path='/observations' component={Observations} />
          <PrivateRoute exact path='/observation' component={ObservationContainer} />
          <PrivateRoute exact path='/newvisit' component={LocationPicker} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
        </Switch>
      </Router>
    </AppProviders>
  );
}

export default App;